export function calculateExponentialBackOff(retries: number): number {
  const backOff = 2 ** retries * 10;

  return backOff;
}

// eslint-disable-next-line no-promise-executor-return
export const wait = (ms: number): Promise<void> => new Promise((res) => setTimeout(res, ms));

export const waitExponentially = (retries: number): Promise<void> =>
  wait(calculateExponentialBackOff(retries));
